import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Navbar from "src/app/components/Navbar";
import Preloader from "src/template/components/Preloader";
import Sidebar from "src/app/components/Sidebar";
import Signin from "./components/authorization/Signin";
import DashboardOverview from "./components/dashboard/DashboardOverview";
import Properties from "./components/property/Properties";
import AddEditProperty from "./components/property/AddEditProperty";
import Users from "./components/user/Users";
import PropertyDetails from "./components/property/PropertyDetails";
import HomeSections from "./components/home-sections/HomeSections";
import PropertyCategory from "./components/PropertyCategory";
import Advert from "./components/advertisement/Advert";
import ContactRequest from "./components/ContactRequest";
import PropertyTag from "./components/PropertyTag";
import PropertySearchIndex from "./components/PropertySearchIndex";
import ImageResources from "./components/ImageResources";

const RouteWithLoader = ({ component: Component, ...props }) => {
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => setLoaded(true), 1000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<>
			<Preloader show={loaded ? false : true} /> <Component {...props} />
		</>
	);
};

const RouteWithSidebar = ({ component: Component, ...props }) => {
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => setLoaded(true), 1000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<>
			<Preloader show={loaded ? false : true} />
			<Sidebar />

			<main className="content">
				<Navbar />
				<Component {...props} />
			</main>
		</>
	);
};

const routePrefix = "/control-panel";

export const routesPath = {
	Home: { path: routePrefix },
	DashboardOverview: { path: routePrefix },
	SignIn: { path: routePrefix + "/sign-in" },
	Properties: { path: routePrefix + "/properties" },
	AddProperty: { path: routePrefix + "/add-property" },
	Users: { path: routePrefix + "/users" },
	HomeSections: { path: routePrefix + "/home-sections" },
	PropertyCategory: { path: routePrefix + "/property-category" },
	PropertyTag: { path: routePrefix + "/property-tag" },
	Advert: { path: routePrefix + "/advertisement" },
	ContactRequest: { path: routePrefix + "/contact-request" },
	SearchScore: { path: routePrefix + "/search-score" },
	ImageResources: { path: routePrefix + "/image-resources" },
};

const routes = ({ is_logged_in, user_data }) => [
	{
		path: routesPath.SignIn.path,
		element: !is_logged_in ? (
			<RouteWithLoader component={Signin} />
		) : (
			<Navigate to={routesPath.Home.path} />
		),
	},
	{
		path: routesPath.Home.path,
		element: is_logged_in ? <Outlet /> : <Navigate to={routesPath.SignIn.path} />,
		children: [
			{
				path: routesPath.DashboardOverview.path,
				element: <RouteWithSidebar component={DashboardOverview} />,
			},
			{
				path: routesPath.Properties.path,
				element: <RouteWithSidebar component={Outlet} />,
				children: [
					{ path: "", element: <Properties /> },
					{
						path: ":id",
						element: <PropertyDetails />,
					},
				],
			},
			{
				path: routesPath.AddProperty.path,
				element: <RouteWithSidebar component={AddEditProperty} />,
			},
			{
				path: routesPath.Users.path,
				element:
					user_data?.roles?.[0]?.id === 1 && user_data?.roles?.[0]?.name === "admin" ? (
						<RouteWithSidebar component={Users} />
					) : (
						<Navigate to={routesPath.Home.path} />
					),
			},
			{
				path: routesPath.HomeSections.path,
				element:
					user_data?.roles?.[0]?.id === 1 && user_data?.roles?.[0]?.name === "admin" ? (
						<RouteWithSidebar component={HomeSections} />
					) : (
						<Navigate to={routesPath.Home.path} />
					),
			},
			{
				path: routesPath.PropertyCategory.path,
				element:
					user_data?.roles?.[0]?.id === 1 && user_data?.roles?.[0]?.name === "admin" ? (
						<RouteWithSidebar component={PropertyCategory} />
					) : (
						<Navigate to={routesPath.Home.path} />
					),
			},
			{
				path: routesPath.PropertyTag.path,
				element:
					user_data?.roles?.[0]?.id === 1 && user_data?.roles?.[0]?.name === "admin" ? (
						<RouteWithSidebar component={PropertyTag} />
					) : (
						<Navigate to={routesPath.Home.path} />
					),
			},
			{
				path: routesPath.Advert.path,
				element:
					user_data?.roles?.[0]?.id === 1 && user_data?.roles?.[0]?.name === "admin" ? (
						<RouteWithSidebar component={Advert} />
					) : (
						<Navigate to={routesPath.Home.path} />
					),
			},
			{
				path: routesPath.ContactRequest.path,
				element:
					user_data?.roles?.[0]?.id === 1 && user_data?.roles?.[0]?.name === "admin" ? (
						<RouteWithSidebar component={ContactRequest} />
					) : (
						<Navigate to={routesPath.Home.path} />
					),
			},
			{
				path: routesPath.SearchScore.path,
				element:
					user_data?.roles?.[0]?.id === 1 && user_data?.roles?.[0]?.name === "admin" ? (
						<RouteWithSidebar component={PropertySearchIndex} />
					) : (
						<Navigate to={routesPath.Home.path} />
					),
			},
			{
				path: routesPath.ImageResources.path,
				element:
					user_data?.roles?.[0]?.id === 1 && user_data?.roles?.[0]?.name === "admin" ? (
						<RouteWithSidebar component={ImageResources} />
					) : (
						<Navigate to={routesPath.Home.path} />
					),
			},
			{ path: "*", element: <Navigate to={routesPath.Home.path} /> },
		],
	},
];

export default routes;
